"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _customerServiceInformation = require("@/api/operationManagement/customerServiceInformation");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CustomerServiceInformation',
  data: function data() {
    return {
      loading: false,
      saveLoading: false,
      form: {
        wechatVisible: 1,
        wechatNo: '',
        wechatQrUrl: '',
        workWechatVisible: 1,
        workWechatNo: '',
        workWechatQrUrl: '',
        qqVisible: 1,
        qqNo: '',
        qqQrUrl: '',
        remarkText: ''
      }
    };
  },
  created: function created() {
    this.getConfig();
  },
  methods: {
    getConfig: function getConfig() {
      var _this = this;
      this.loading = true;
      (0, _customerServiceInformation.getCustomerConfig)().then(function (res) {
        var data = res.data || {};
        _this.form = {
          wechatVisible: Number(data.wechatVisible || 0),
          wechatNo: data.wechatNo || '',
          wechatQrUrl: data.wechatQrUrl || '',
          workWechatVisible: Number(data.workWechatVisible || 0),
          workWechatNo: data.workWechatNo || '',
          workWechatQrUrl: data.workWechatQrUrl || '',
          qqVisible: Number(data.qqVisible || 0),
          qqNo: data.qqNo || '',
          qqQrUrl: data.qqQrUrl || '',
          remarkText: data.remarkText || ''
        };
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(field, _ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.form[field] = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleSave: function handleSave() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认保存客服信息配置？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this2.saveLoading = true;
            (0, _customerServiceInformation.saveCustomerConfig)(_this2.form).then(function () {
              _this2.$notify.success({
                title: '温馨提示',
                message: '保存成功'
              });
              _this2.getConfig();
            }).finally(function () {
              _this2.saveLoading = false;
            });
          }).catch(function () {});
        }
      });
    },
    handleReset: function handleReset() {
      this.$refs.form.resetFields();
      this.$message.info('已重置');
    }
  }
};